import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const FillRateBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const allLabels = ['Automotriz', 'Manufactura', 'Construcción', 'Retail', 'Alimentos', 'Salud/Farmacéutica', 'Servicios logísticos'];

  const data2023 = [90, 94, 94, 95, 96, 96, 97];
  const data2024 = [97, 98, 90, 93, 97, 100, 98];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;
  const dataValues2023 = labels.map(label => data2023[allLabels.indexOf(label)]);
  const dataValues2024 = labels.map(label => data2024[allLabels.indexOf(label)]);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2022',
        data: dataValues2023,
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2023',
        data: dataValues2024,
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 40, // Aumentar el padding inferior
        left: 20,
        right: 20,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#fff',
        anchor: 'end',
        align: 'start',
        formatter: (value) => `${value}`,
        font: { weight: 'bold', size: 14 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
        },
        stacked: false,
      },
      y: {
        title: {
          display: true,
          text: 'Porcentaje (%)',
        },
        beginAtZero: true,
        max: 100,
        stacked: false,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const industry = chartData.labels[index];
        onBarClick([industry]);
      }
    },
  };

  const infoContent = {
    Analisis: ': El estudio refleja un fortalecimiento en el desempeño logístico de las industrias en 2023, destacando avances clave en sectores como Automotriz, Manufactura y Salud, este último alcanzando un cumplimiento del 100%. Esto confirma una tendencia positiva en eficiencia y madurez operativa dentro de las cadenas de suministro en México.',
    formula: 'Tasa de Surtido de Ventas (%) = (Total de piezas entregadas / Total de piezas solicitadas) × 100',
    description: 'La gráfica muestra la tasa de llenado promedio para diferentes industrias en los años 2022 y 2023. Este indicador mide el porcentaje de pedidos completados con éxito en comparación con los pedidos totales realizados.',
  };
  
  return (
    <div style={{ width: '100%', height: '555px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
        <p><strong>Análisis:</strong> {infoContent.Analisis}</p>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FillRateBar;
